import { ReturnComponent } from '@/utils/reactTypes';
import { Suspense, lazy } from 'react';

import { areFlagOverridesAvailable } from './flagOverrideGate';

// Split out so the panel, the console handle and the flag catalog stay out of the bundle an
// environment that cannot use them downloads.
const FeatureFlagOverrideTools = lazy(() =>
    import('./FeatureFlagOverrideTools').then((m) => ({ default: m.FeatureFlagOverrideTools })),
);

export const FeatureFlagOverrideMount = (): ReturnComponent => {
    if (!areFlagOverridesAvailable) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <FeatureFlagOverrideTools />
        </Suspense>
    );
};
